import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { LOSS_REASONS, slug } from "@/lib/constants";
import { useData } from "@/context/DataContext";

export const LossReasonDialog = () => {
  const { pendingLost, setPendingLost, commitMove } = useData();
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  useEffect(() => { setReason(""); setError(""); }, [pendingLost]);

  const confirm = () => {
    if (!reason) return setError("Pick a loss reason");
    commitMove(pendingLost.id, "Lost", reason);
    setPendingLost(null);
  };

  return (
    <Dialog open={!!pendingLost} onOpenChange={(o) => !o && setPendingLost(null)}>
      <DialogContent data-testid="loss-reason-dialog" className="max-w-[calc(100vw-2rem)] rounded-2xl border-slate-800 bg-slate-900 text-slate-100 sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display">Why was {pendingLost?.name} lost?</DialogTitle>
          <DialogDescription>A loss reason is required to move a card to Lost.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          {LOSS_REASONS.map((r) => (
            <button key={r} type="button" data-testid={`loss-reason-option-${slug(r)}`} onClick={() => { setReason(r); setError(""); }}
              className={`reason-opt ${reason === r ? "reason-opt-active" : ""}`}>{r}</button>
          ))}
        </div>
        {error && <p data-testid="loss-reason-error" className="field-error">{error}</p>}
        <DialogFooter className="gap-2 sm:gap-0">
          <button type="button" data-testid="loss-reason-cancel-btn" onClick={() => setPendingLost(null)} className="btn-ghost">Cancel</button>
          <button type="button" data-testid="loss-reason-confirm-btn" onClick={confirm} className="btn-primary">Move to Lost</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
